import { PHONE, locationSchema } from "../structured-data-core";

export function getColumbusStructuredData() {
  const url = "https://restorehair.com/locations/ohio/columbus/";
  const description =
    "Find out about your hair transplant options in Columbus with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Columbus", "100 E. Campus View Boulevard, Suite 250", "Columbus", "OH", PHONE, url, description),
  ];
}
